import React, { useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import usePortal from 'react-cool-portal';
import { useUpdateEffect } from 'ahooks';
import { timeline, spring, animate } from 'motion';
import classNames from 'classnames';
import FocusLock from 'react-focus-lock';

export const ReactDrawer = ({ parentNode, showDrawer, setShowDrawer, children, className, position, id }) => {


  const drawerPosition = {
    left: {
      start: { x: ["-100%", 0] },
      end: { x: [0, "-100%"] }
    },
    right: {
      start: { x: ["100%", 0] },
      end: { x: [0, "100%"] }
    },
    top: {
      start: { y: ["-100%", 0] },
      end: { y: [0, "-100%"] }
    }
  }


  const wrapperRef = useRef(null);
  const drawerInnerEl = useRef(null);
  const {
    Portal,
    isShow,
    show: showPortal,
    hide: hidePortal,
    toggle: togglePortal,
  } = usePortal({
    defaultShow: false,
    containerId: 'modals-container',
    clickOutsideToHide: false,
    autoRemoveContainer: false,
    onShow: (e) => {
      setTimeout(() => {

        animate(wrapperRef.current, { display: 'block', pointerEvents: 'all' }, { duration: 0 });
        let sequence = [
          [wrapperRef.current, { opacity: [0, 1] }],
          [drawerInnerEl.current, { opacity: [0, 1], ...drawerPosition[position].start }],
        ];


        timeline(sequence);
        const scroller = drawerInnerEl.current.querySelector('.drawer-scroller') ? drawerInnerEl.current.querySelector('.drawer-scroller') : drawerInnerEl.current
        disableBodyScroll(scroller);
      }, 100);
    },
    onHide: (e) => {
      clearAllBodyScrollLocks();
      animate(wrapperRef.current, { pointerEvents: 'none' });
    },
  });

  // Bind Esc key to close the modal
  useEffect(() => {
    if (showDrawer) {
      function handleKeyUp(event) {
        switch (event.key) {
          case 'Escape':
            setShowDrawer(false);
            break;
        }
      }
      window.addEventListener('keyup', handleKeyUp);
      return () => window.removeEventListener('keyup', handleKeyUp);
    }
  }, [showDrawer]);

  useUpdateEffect(() => {
    if (showDrawer) {
      showPortal();
    } else {
      let sequence = [
        [drawerInnerEl.current, { ...drawerPosition[position].end, opacity: [1, 0] }],
        [wrapperRef.current, { opacity: [1, 0] }],
      ];
      timeline(sequence).finished.then(() => {
        hidePortal();
      });
    }
  }, [showDrawer]);

  return (
    <>
      <Portal>
        <FocusLock disabled={!isShow} returnFocus={{ preventScroll: false }} >
          <div className={`Drawer ${classNames(className, { 'is-open': showDrawer })}`} ref={wrapperRef}>
            <div
              custom={position}
              className="Drawer__inner"
              ref={drawerInnerEl}
              id={id}
              tabIndex="-1"
            >
              {children}
            </div>
            <span className="backdrop" onClick={() => setShowDrawer(false)}></span>
          </div>
        </FocusLock>
      </Portal>
    </>
  );
};
